import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import HotComicsGrid from "./components/HotComicsGrid";
import CategoryGallery from "./components/CategoryGallery";
import QuickNavSection from "./components/QuickNavSection";
import StatsSection from "./components/StatsSection";
import TestimonialSection from "./components/TestimonialSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotComicsGrid />
        <CategoryGallery />
        <QuickNavSection />
        <StatsSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}